import { assign } from 'lodash';
import { updateArrayItemByID } from 'utils/array';
import * as api from 'api/api-instance';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  search: false,
  saving: false,
  empty: false,
  saveError: null,
  error: null,
  notFound: null,
  meta: {},
  data: [],
};

const neutralState = {
  fetching: false,
  fetched: true,
  search: false,
  saving: false,
  empty: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = assign({}, initState);

const getters = {
  InstanceSourcesList: state => state,
};

const actions = {
  GetInstanceSourcesList({ commit }) {
    commit(types.FETCH_INSTANCE_SOURCES_LIST_START);
    api.getSources(
      (response) => {
        commit(types.RECEIVE_INSTANCE_SOURCES_LIST, { response });
      },
      (description, status, error) => {
        commit(types.FETCH_INSTANCE_SOURCES_LIST_ERROR, { error });
      },
    );
  },
  UpdateInstanceSourceAndFeaturesList({ commit }, payload) {
    commit(types.UPDATE_INSTANCE_SOURCE_AND_FEATURES_LIST, { payload });
  },
  ClearInstanceSourcesList({ commit }) {
    commit(types.CLEAR_INSTANCE_SOURCES_LIST_STORE);
  },
};

const mutations = {
  [types.FETCH_INSTANCE_SOURCES_LIST_START](state) {
    assign(state, neutralState, { fetching: true });
  },
  [types.FETCH_INSTANCE_SOURCES_LIST_ERROR](state, { error }) {
    assign(state, neutralState, { error });
  },
  [types.RECEIVE_INSTANCE_SOURCES_LIST](state, { response }) {
    assign(state, neutralState, { ready: true, meta: response.meta, data: response.data });
  },
  [types.CLEAR_INSTANCE_SOURCES_LIST_STORE](state) {
    assign(state, initState);
  },
  [types.UPDATE_INSTANCE_SOURCE_AND_FEATURES_LIST](state, { payload }) {
    const source = payload.Source;
    const features = payload.Features;
    updateArrayItemByID(state.data.Sources, source);
    assign(state.data.features, features);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/instance/entities/instance-sources-list.js